module.exports = __webpack_public_path__ + "img/STAR SHADES LIME.6635a76.svg";